export const layoutNames = { 1: 'Alternating image and text', 2: 'Checklist', 3: 'Feature cards', 4: 'Text section', 5: 'Logo gallery', 6: 'Image grid', 7: 'Content cards', 8: 'Image and checklist' };
export const layoutName = section => layoutNames[section?.value ?? section?.section_id] || section?.name || 'Custom layout';
export const requestHeaders = () => ({ Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('data')) });
export const formDataFor = values => {
    const form = new FormData();
    Object.entries(values).forEach(([key, value]) => {
        if (key === 'image' && !(value instanceof File)) return;
        form.append(key, value ?? '');
    });
    return form;
};
export const errorMessage = error => {
    const message = error.response?.data?.message;
    return typeof message === 'string' ? message : message ? Object.values(message).flat().join(' ') : 'Unable to reach the server. Please try again.';
};

export const layoutHelp = {
    1: 'Each item becomes a full-width row. The first image appears on the right; following rows alternate sides. Images and text stack on mobile.',
    2: 'Items appear as a two-column checklist on desktop and a single list on mobile.',
    3: 'Each item becomes a feature card. Cards sit in two columns on desktop and stack on mobile.',
    4: 'A full-width text section. Only the section heading and rich text appear here. This theme has no items.',
    5: 'Items form a logo gallery: four columns on desktop and two on mobile. Images fit without cropping.',
    6: 'Items become image tiles: three columns on desktop, two on tablet and one on small screens.',
    7: 'Items become cards with images and descriptions: three columns on desktop and one on mobile.',
    8: 'The section image sits beside its introduction. Checklist items sit below the introduction, beside the image. Everything stacks on mobile.',
};

const themeFields = {
    1: [[], ['heading', 'content', 'image', 'alt']],
    2: [['heading'], ['heading']],
    3: [['heading'], ['heading', 'content']],
    4: [['heading', 'content'], []],
    5: [['heading'], ['image', 'alt']],
    6: [['heading'], ['heading', 'image', 'alt']],
    7: [['heading', 'content'], ['heading', 'content', 'image', 'alt']],
    8: [['heading', 'content', 'image', 'alt'], ['heading', 'content']],
};
export const fieldsFor = (theme, scope = 'section') => themeFields[theme]?.[scope === 'section' ? 0 : 1] || [];
export const supportedValues = (value, theme, scope) => Object.fromEntries(
    ['id', 'section_id', 'page_section_id', 'sort_order', ...fieldsFor(theme, scope)]
        .filter(key => value[key] !== undefined).map(key => [key, value[key]])
);
